module.exports = __webpack_public_path__ + "img/cartpage-icon.69c083cb.svg";